module.exports = __webpack_public_path__ + "static/media/Mulish-Black.783d04e3.ttf";